import React from 'react'
import {graphql} from 'gatsby'
import LegalPageTemplate from '../../components/templates/legal/LegalPageTemplate'

const PrivacyPolicyPage = ({data}) => {
    return <LegalPageTemplate data={data} />
}

export const query = graphql`
  query PrivacyPolicyPageQueryNl {
    markdownRemark(
      frontmatter: {
        type: {eq: "privacy"}
        language: {eq: "nl"}
      }
    ) {
      html
      frontmatter {
        title
        language
        type
        lastUpdated
      }
    }
  }
`

export default PrivacyPolicyPage
